import { render, staticRenderFns } from "./VehicleTeam.vue?vue&type=template&id=2081a7d9&scoped=true&"
import script from "./VehicleTeam.vue?vue&type=script&lang=js&"
export * from "./VehicleTeam.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTeam.vue?vue&type=style&index=0&id=2081a7d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081a7d9",
  null
  
)

export default component.exports